import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

import { computed, PropType } from "vue";
import { Document } from "@/types";
import Ok from "@/components/general/Ok.vue";

const maxDays = 28; // todo get from company settings


export default /*#__PURE__*/_defineComponent({
  __name: 'PaidStatus',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    size: {
        type: Number,
        default: 20,
    },
},
  setup(__props) {

const props = __props;

const daysLate = computed(() => {
    const today = new Date().getTime();
    const invoiceDate = new Date(
        props.document.year +
            "-" +
            props.document.month +
            "-" +
            props.document.day
    ).getTime();
    const difference = today - invoiceDate;
    const msPerDay = 1000 * 60 * 60 * 24;
    return Math.round(difference / msPerDay - maxDays);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.document.paid)
      ? (_openBlock(), _createBlock(Ok, {
          key: 0,
          size: __props.size
        }, null, 8, ["size"]))
      : _createCommentVNode("", true),
    (!__props.document.paid)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["PaidStatus", { 'PaidStatus--alert': daysLate.value > 0 }])
        }, _toDisplayString(daysLate.value), 3))
      : _createCommentVNode("", true)
  ], 64))
}
}

})